import SpainAgreementCode from 'modules/contracts/store/models/SpainAgreementCode'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class AgreementCodes extends PayrollLegalEntityResource<SpainAgreementCode> {
  get cacheKey(): string {
    return 'agreementCodes'
  }

  model() {
    return SpainAgreementCode
  }
}

export { AgreementCodes }
